import {Duration} from 'luxon';
import * as numeral from 'numeral';

import {defineMessages, useIntl} from '@pinecast/i18n';

const messages = defineMessages({
  duration: {
    id: 'common.Duration.duration',
    description: 'Label for the duration of an episode.',
    defaultMessage: '{minutes} minutes, and {seconds} seconds',
  },
  durationLong: {
    id: 'common.Duration.duration.long',
    description: 'Label for the duration of an episode.',
    defaultMessage: '{hours} hours, {minutes} minutes, and {seconds} seconds',
  },
});

type Props = {
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  seconds: number;
};

const DurationComponent = ({as: As = 'div', className, seconds}: Props) => {
  const intl = useIntl();

  const duration = Duration.fromMillis(seconds * 1000);
  return (
    <As
      aria-label={
        duration.hours
          ? intl.formatMessage(messages.durationLong, {
              hours: duration.hours,
              minutes: duration.minutes,
              seconds: duration.seconds,
            })
          : intl.formatMessage(messages.duration, {
              minutes: duration.minutes,
              seconds: duration.seconds,
            })
      }
      className={className}
    >
      {numeral(seconds).format('00:00:00')}
    </As>
  );
};

export default DurationComponent;
